import axios from 'axios';
import { getToken } from './auth';

const API_URL = 'https://backend.chamafruits.com';

const withAuth = () => ({
  headers: { Authorization: `Bearer ${getToken()}` },
  withCredentials: true,
});

export const getCategories = async (params = {}) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    query.set(key, String(value));
  });
  const suffix = query.toString() ? `?${query.toString()}` : '';
  return (await axios.get(`${API_URL}/categories${suffix}`, withAuth())).data;
};

export const createCategory = async (payload) =>
  (await axios.post(`${API_URL}/categories`, payload, withAuth())).data;

export const updateCategory = async (categoryId, payload) =>
  (await axios.patch(`${API_URL}/categories/${categoryId}`, payload, withAuth())).data;

export const deleteCategory = async (categoryId) =>
  (await axios.delete(`${API_URL}/categories/${categoryId}`, withAuth())).data;

export const updateCategoryAvailability = async (categoryId, availability) =>
  (await axios.put(
    `${API_URL}/categories/${categoryId}/availability`,
    { availability },
    withAuth()
  )).data;
